import { CSSProperties } from "react";

export const ChartStyles = {
  tooltipContentStyle: {
    color: '#f8fafc',
    background: 'rgba(15, 23, 42, 0.92)',
    border: 'none',
    boxSizing: 'border-box',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    borderRadius: 8,
    padding: '8px 12px',
    fontSize: '12px',
  } as CSSProperties,
  tooltipItemStyle: {
    background: 'transparent !important',
    padding: '2px 0',
  },
  tooltipWrapperStyle: {
    top: -50,
  },
  areaChartMargin: {
    top: 8,
    right: 16,
    bottom: 8,
    left: 0,
  },
  targetsChartMargin: {
    top: 34,
    right: 0,
    bottom: 0,
    left: 15,
  },
  barChartMargin: {
    top: 8,
    right: 24,
    bottom: 8,
    left: 16,
  },
  cartesianGrid: {
    stroke: '#f1f5f9',
    strokeDasharray: '4 4',
  },
};

export const ChartSettings = {
  tick: {
    fill: '#64748b',
    fontSize: '11px',
    lineHeight: 16,
  },
  xAxisLabel: {
    angle: -90,
    position: 'center',
    dx: -15,
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.5,
    lineHeight: 14,
    fill: '#475569',
  },
};
